import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/my/leaves/$leaveId',
}).lazy(() => import('./$leaveId.index.lazy').then((d) => d.Route))
